/* ============================================
   SLIMEZONE EASTER SHOW 2026 — Landing Page JS
   ============================================ */

(function() {
  'use strict';

  /* --- Smooth Scroll for Anchor Links --- */
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a[href*="#"]');
    if (!link) return;

    const href = link.getAttribute('href');
    let hash;

    // Handle both full URLs with hash and hash-only links
    if (href.startsWith('#')) {
      hash = href;
    } else {
      try {
        const url = new URL(href, window.location.origin);
        if (url.pathname === window.location.pathname || url.pathname === '/') {
          hash = url.hash;
        }
      } catch (err) {
        return;
      }
    }

    if (!hash || hash === '#') return;

    const target = document.querySelector(hash);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });

      // Update URL without triggering scroll
      history.pushState(null, null, hash);

      // Close mobile menu if open
      const menuDrawer = document.querySelector('details[id^="Details-menu"]');
      if (menuDrawer && menuDrawer.hasAttribute('open')) {
        menuDrawer.removeAttribute('open');
      }
    }
  });

  /* --- Header CTA Button Styling --- */
  function styleHeaderCTA() {
    const menuItems = document.querySelectorAll('.header__menu-item');
    menuItems.forEach(function(item) {
      const link = item.querySelector('a');
      if (link && link.textContent.trim().toLowerCase().includes('book')) {
        item.classList.add('header__menu-item--cta');
      }
    });
  }

  /* --- Scroll-Based Header Background --- */
  function initHeaderScroll() {
    const header = document.querySelector('.header-wrapper');
    if (!header) return;

    let lastScroll = 0;
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 100) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* --- Initialize on DOM Ready --- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    styleHeaderCTA();
    initHeaderScroll();
  }
})();
